export const COLUMN_PERIOD = 'period';
export const COLUMN_APPLICATION = 'application';
export const COLUMN_TOTAL_SPEND = 'spend';
export const COLUMN_LAST_UPDATED = 'updatedDateTime';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_CREATED = 'createdDateTime';

export const TEMPLATE_NEW_MAIN_BUDGET_PLANNING = 'NewMainBudgetPlanning';
